import constants from '../constants';
import { shields } from '../web3/SFM-ShieldConstants';
export const ShieldsData = [
  {
    name: 'lectro Magneto Shield',
    type: 'Shield',
    description: constants.Electro_Magneto_shield,
    price: '$5,00',
    image:
      'https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/shields/Electro%20Magneto%20shield.gif',
    category: shields.electroMagnetoShield,
  },
  {
    name: 'Plasma Membrane Shield',
    type: 'Shield',
    description: constants.Plasma_Membrane_shield,
    price: '$8,00',
    image:
      'https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/shields/Plasma%20Membrane%20shield.gif',
    category: shields.plasmaMembraneShield,
  },
  {
    name: 'Hydra Shield',
    type: 'Shield',
    description: constants.Hydra_shield,
    price: '$7,00',
    image:
      'https://scarlet-adequate-clownfish-387.mypinata.cloud/ipfs/QmQQKjiBZ3LVHcHgLmuvc8QyCn1WpNMPQxxcsvwMGohoDK/shields/Hydra%20shield.gif',
    category: shields.hydraShield,
  },
];
